import {
  NamespaceFormValues,
  NamespacePayload,
  ResourceQuotaPayload,
} from '../../types';

export function transformFormValuesToNamespacePayload(
  createNamespaceFormValues: NamespaceFormValues,
  owner: string
): NamespacePayload {
  return {
    Name: createNamespaceFormValues.name,
    Owner: owner,
    Annotations: createNamespaceFormValues.annotations.reduce(
      (acc, { key: Key, value: Value }) => ({ ...acc, [Key]: Value }),
      {}
    ),
    ResourceQuota: {
      enabled: createNamespaceFormValues.resourceQuota.enabled,
      cpuRequest: createNamespaceFormValues.resourceQuota.cpuRequest || '0',
      cpuLimit: createNamespaceFormValues.resourceQuota.cpuLimit || '0',
      memoryRequest:
        createNamespaceFormValues.resourceQuota.memoryRequest || '0',
      memoryLimit: createNamespaceFormValues.resourceQuota.memoryLimit || '0',
    } as ResourceQuotaPayload,
    LoadBalancerQuota: createNamespaceFormValues.loadBalancerQuota,
    StorageQuotas: createNamespaceFormValues.storageQuota.reduce(
      (acc, storageClass) => ({
        ...acc,
        [storageClass.className]: {
          enabled: storageClass.enabled,
          limit: storageClass.size
            ? `${storageClass.size}${storageClass.sizeUnit}`
            : undefined,
        },
      }),
      {}
    ),
  };
}
